export * from './ViewSurpriseModal';
export { default } from './ViewSurpriseModal';
